'use strict';

module.exports = clickEvent;

function clickEvent(handler, opts) {
    opts = opts || {};

    return function clickHandler(ev) {
        ev.preventDefault();

        if (!opts.ctrl && ev.ctrlKey) {
            return;
        }

        if (!opts.meta && ev.metaKey) {
            return;
        }

        if (!opts.rightClick && ev.which === 2) {
            return;
        }

        handler();
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/mercury-router/lib/click-event.js
// module id = 141
// module chunks = 0